import 'react-date-picker/index.css';
import 'material-design-lite/src/material-design-lite.scss';
import 'material-design-icons-iconfont/dist/material-design-icons.scss';
//---
import '../autocomplete-select/index.scss';
import '../autocomplete-text/index.scss';
import '../button/style/button.scss';
import '../button-back/style/back.scss';
import '../button-back-to-top/style/back-to-top.scss';
import '../chips/index.scss';
import '../confirmation-popin/index.scss';
import '../draggable-iframe/style/draggable-iframe.scss';
import '../dropdown/index.scss';
import '../header-actions/index.scss';
import '../input-checkbox/style/checkbox.scss';
import '../input-date/index.scss';
import '../input-radio/style/radio.scss';
import '../input-textarea/style/textarea.scss';
import '../label/style/label.scss';
import '../modal/index.scss';
import '../menu/index.scss';
import '../panel/index.scss';
import '../progress-bar/style/progress-bar.scss';
import '../scrollspy-container/style/scrollspy-container.scss';
import '../scrollspy-container/style/sticky-menu.scss';
import '../select-mdl/index.scss';
import '../select/index.scss';
import '../select-radio/style/select-radio.scss';
import '../snackbar/index.scss';
import '../spinner/mdl-progress.scss';
import '../spinner/pacman.scss';
import '../tooltip/style/tooltip.scss';

//STYLE FOLDER
import '../style/animation.scss';
import '../style/spinner.scss';



// WEBPACK FOOTER //
// ./src/style/index.js